import { OrePill, SvgBankTransfer, SvgDomiciliaryReceipt } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { contractTranslation } from '@/Contract/ui/contractTranslation'

interface IProps {
  state: number
}

export const ContractPaymentMethodPill = ({ state }: IProps): JSX.Element => {
  const { t } = useTranslation()

  const textPill =
    state === 1
      ? t(contractTranslation.productsData.summary.methods.transfer)
      : t(contractTranslation.productsData.summary.methods.moneyCheck)

  const iconPill = state === 1 ? <SvgDomiciliaryReceipt /> : <SvgBankTransfer />

  return (
    <OrePill tone={'cobalt-600'} icon={iconPill}>
      {textPill}
    </OrePill>
  )
}
